/**
 * Sprachkennungen (LCID), wie VBA sie für `LanguageID` meldet, übersetzt in
 * die sprachunabhängigen Namen, die auch Office.js verwendet.
 */
export function vbaSprache(id: number): string {
  if ([1031, 2055, 3079, 4103, 5127].includes(id)) return "German";
  if (id === 1033) return "EnglishUS";
  if ([2057, 3081, 4105, 5129, 6153].includes(id)) return "EnglishUK";
  if (id === 1036) return "French";
  if (id === 1040) return "Italian";
  if (id === 3082 || id === 1034) return "Spanish";
  return `LCID ${id}`;
}
